import * as React from "react";
import { Icon, Grid, Button, Typography, LinkText } from './index';
import { PageHeading } from './mybswh';
import './test_component.scss';

class ComponentTest extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            checked: true
        };
    }

    toggleChecked = (e) => {
        this.setState({ checked: !this.state.checked });
    }

    render() {
        return (
            <Grid className="body-content bsw-test-components">
                <div className="row">
                    <div className="col-12">
                        <PageHeading heading="Components" />
                        <Icon name="message-notification" />
                        <LinkText
                            to="/pagenotfound"
                            icon="arrow"
                            iconPosition="right"
                            decorator="mobile"
                        >Test</LinkText>
                    </div>
                </div>
            </Grid>
        );
    }

}

export default ComponentTest;
